export const combine = (...paths: string[]) => {
  return paths
    .map((path) => path.replace(/^[\\|/]/, "").replace(/[\\|/]$/, ""))
    .join("/")
    .replace(/\\/g, "/");
};
